import { apiFetch } from './http';

/**
 * One recipe+world of an inspection campaign, and where its own run through
 * the tour stands (InspectionCampaignItem.State): `pending`, `starting`,
 * `waiting_live`, `connecting`, `settling`, `inspecting`, `disconnecting`,
 * `done`, `failed`.
 */
export type InspectionCampaignItemState =
  | 'pending'
  | 'starting'
  | 'waiting_live'
  | 'connecting'
  | 'settling'
  | 'inspecting'
  | 'disconnecting'
  | 'done'
  | 'failed'
  | string;

export interface InspectionCampaignItemView {
  index: number;
  recipeId: string;
  recipeTitle: string;
  worldClass: string;
  state: InspectionCampaignItemState;
  sessionCode: string | null;
  missionCode: string | null;
  uploadCount: number;
  error: string | null;
  /** 0 until the first restart from a game/watcher failure, 1 after it; a second such failure fails the item for good. */
  retryCount: number;
  startedAt: string | null;
  finishedAt: string | null;
}

/** `running`, `done`, `failed`, `cancelled` (InspectionCampaign.State). */
export type InspectionCampaignState = 'running' | 'done' | 'failed' | 'cancelled' | string;

export interface InspectionCampaignView {
  id: number;
  state: InspectionCampaignState;
  currentItem: number;
  totalItems: number;
  panelServerId: number | null;
  accountId: number | null;
  candidateMod: string | null;
  createdBy: number | null;
  createdAt: string;
  updatedAt: string;
  items: InspectionCampaignItemView[];
}

/** `/proves/inspeccions/campanya/:id`, refreshed every 15 s while it runs. */
export const fetchInspectionCampaign = (id: number | string) =>
  apiFetch<InspectionCampaignView>(`/api/inspections/campaigns/${id}`);

export const fetchInspectionCampaigns = () =>
  apiFetch<InspectionCampaignView[]>('/api/inspections/campaigns');

/** «Atura la campanya»: the ticker leaves it alone from the next tick on; whatever the current item is mid-doing finishes that step. */
export const cancelInspectionCampaign = (id: number | string) =>
  apiFetch<InspectionCampaignView>(`/api/inspections/campaigns/${id}/cancel`, { method: 'POST' });

/** «Reprèn»: only a cancelled campaign moves back to running. */
export const resumeInspectionCampaign = (id: number | string) =>
  apiFetch<InspectionCampaignView>(`/api/inspections/campaigns/${id}/resume`, { method: 'POST' });
